import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession, signInWithRedirect, signOut, getCurrentUser } from '@aws-amplify/auth';
import type { RuntimeConfig } from './config';



export function configureAuth(cfg: RuntimeConfig) {
  if (cfg.userPoolId === 'local') return; // local mock mode — skip real Cognito wiring
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cfg.userPoolId,
        userPoolClientId: cfg.userPoolClientId,
        loginWith: {
          oauth: {
            domain: `${cfg.userPoolDomain}.auth.${cfg.region}.amazoncognito.com`,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [`${window.location.origin}/auth/callback`],
            redirectSignOut: [`${window.location.origin}/`],
            responseType: 'code',
          },
        },
      },
    },
  });
}

export async function getIdToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
}

export async function currentUser() {
  try { return await getCurrentUser(); } catch { return null; }
}

export const login = () => signInWithRedirect();
export const logout = () => signOut();
